import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedService } from "../services/shared.service";

@Component({
  selector: 'app-team-name',
  templateUrl: './team-name.component.html',
  styleUrls: ['./team-name.component.scss']
})
export class TeamNameComponent implements OnInit {

  @Input() name: string = "";
  @Input() maxLength: number = 125;
  @Input() darkBackground: boolean = false;
  @Output() nameChange = new EventEmitter<string>();
  charCount: number = 0;

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.updateCharCount();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['name']) {
      this.updateCharCount();
    }
  }

  updateCharCount() {
    if (this.name.length > this.maxLength) this.name = this.name.substring(0, this.maxLength);
    this.charCount = this.name.length;
  }

  onModelChange(newValue: string) {
    this.name = newValue;
    this.handleChange();
  }

  generateTeamName() {
    this.name = this.sharedService.generateTeamName()
    this.handleChange();
  }

  handleChange() {
    this.updateCharCount();
    this.nameChange.emit(this.name);
  }

}
